import workflowRoleReducer from "./workflowRoleReducer";
import regionSettingReducer from "./regionSettingReducer";
import documentReviewerReducer from "./documentReviewerReducer";
import assessmentDecisionReviewerReducer from "./assessmentDecisionReviewerReducer";

const workflowRoleSettingReducers = {
    workflowRole: workflowRoleReducer,
    regionSetting: regionSettingReducer,
    documentReviewer: documentReviewerReducer,
    assessmentDecisionReviewer: assessmentDecisionReviewerReducer,
}

export default workflowRoleSettingReducers;